import { ca } from '@cian/analytics';

export function trackTransferToDeveloperCard() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'click_sopr',
    label: 'to_card_builder',
    useLastProducts: true,
  });
}

interface ITrackShowPhoneParams {
  gaLabel: string;
  newbuildingId: number;
  isBuilder: boolean;
}

export const trackShowPhone = ({ gaLabel, newbuildingId, isBuilder }: ITrackShowPhoneParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'author_contacts_block',
    label: gaLabel,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    page: {
      extra: {
        pageType: 'JK',
        seller_type: isBuilder ? 'builders' : 'agents',
      },
    },
  });
};
